import { RequestService } from "../../../../common/services/RequestService";
import {GET_STOPS_LIST} from "./constants";

export const getStopsListRequest = async (orderId) => {
  const response = await RequestService.get(
    GET_STOPS_LIST.replace("{order_id}", orderId)
  );
  return response;
};
